import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60154e28"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tab-pane fade show active m-2 tab-content",
  id: "StatusTabContent",
  role: "tabpanel",
  "aria-labelledby": "home-tab"
}
const _hoisted_2 = {
  id: "statusFormContainer",
  class: "txtLeft"
}
const _hoisted_3 = { class: "row mb-3" }
const _hoisted_4 = { class: "col-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "facility", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "department", -1))
const _hoisted_9 = { class: "col-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "from date", -1))
const _hoisted_11 = { class: "col-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "to date", -1))
const _hoisted_13 = { class: "col-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "shift", -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = { class: "col-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "skill", -1))
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "col-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "specialization", -1))
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 0,
  id: "divSkillsErrorMessage",
  class: "font-small text-start",
  style: {"display":"block"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " No specialization available for this department. ", -1))
const _hoisted_28 = { class: "col-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "Status", -1))
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "col-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "Result", -1))
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "col-2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "ContractLaborId", -1))
const _hoisted_36 = {
  class: "col-2 search-wrapper",
  style: {"padding-top":"20px"}
}
const _hoisted_37 = { class: "activityLog-grid-container mt-2" }
const _hoisted_38 = {
  key: 0,
  id: "status-content-loading",
  class: "text-center mt-3"
}
const _hoisted_39 = { class: "fa-2x" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1))
const _hoisted_41 = {
  key: 1,
  id: "statusGrid"
}
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 2 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { key: 2 }
const _hoisted_50 = {
  key: 1,
  id: "period-message-text"
}
const _hoisted_51 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_input = _resolveComponent("neu-input")!
  const _component_neu_button = _resolveComponent("neu-button")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!
  const _component_neu_paginator = _resolveComponent("neu-paginator")!
  const _component_neu_col = _resolveComponent("neu-col")!
  const _component_neu_table_row_count = _resolveComponent("neu-table-row-count")!
  const _component_neu_row = _resolveComponent("neu-row")!
  const _component_neu_container = _resolveComponent("neu-container")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("select", {
              class: "neu-select",
              name: "facility",
              id: "facilityDropdown",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFacilities) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFacilityChange && _ctx.onFacilityChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facilities, (fac) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: fac.Value,
                  key: fac.Value
                }, _toDisplayString(fac.Text), 9, _hoisted_6))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.selectedFacilities]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.selectedDepartments,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDepartments) = $event)),
                _ctx.onDepartmentChange
              ],
              options: _ctx.departments,
              multiple: true,
              searchable: true,
              "close-on-select": true,
              placeholder: "All Departments...",
              label: "Text",
              "track-by": "Text",
              id: "selDepartments"
            }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.selectedStartDate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedStartDate) = $event)),
              weekStart: "0",
              inputClassName: "dp-custom-input",
              class: "form-control requestDate",
              style: {"width":"100%"},
              enableTimePicker: false,
              autoApply: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.selectedEndDate,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedEndDate) = $event)),
              weekStart: "0",
              inputClassName: "dp-custom-input",
              class: "form-control requestDate",
              style: {"width":"100%"},
              enableTimePicker: false,
              autoApply: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("select", {
              class: "neu-select",
              name: "departmentShifts",
              id: "departmentShifts",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedShift) = $event)),
              disabled: _ctx.isDepartmentShiftDisable
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shifts, (shift) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: shift.deptShiftId,
                  key: shift.deptShiftId
                }, _toDisplayString(shift.deptShiftDescription), 9, _hoisted_16))
              }), 128))
            ], 8, _hoisted_15), [
              [_vModelSelect, _ctx.selectedShift]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _withDirectives(_createElementVNode("select", {
              class: "neu-select",
              name: "fsskills",
              id: "fsskills",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedSkill) = $event)),
              disabled: _ctx.isSkillDisable
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (skl) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: skl.SkillLevelId,
                  key: skl.SkillLevelId
                }, _toDisplayString(skl.Description), 9, _hoisted_21))
              }), 128))
            ], 8, _hoisted_20), [
              [_vModelSelect, _ctx.selectedSkill]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _withDirectives(_createElementVNode("select", {
              class: "neu-select",
              name: "skillSpecialization",
              id: "skillSpecialization",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedSkillSpecialization) = $event)),
              disabled: _ctx.isskillSpecializationDisable
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skillSpecializations, (fac) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: fac.wfFoldergroupID,
                  key: fac.wfFoldergroupID
                }, _toDisplayString(fac.wfFolderGroupName), 9, _hoisted_25))
              }), 128))
            ], 8, _hoisted_24), [
              [_vModelSelect, _ctx.selectedSkillSpecialization]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            }),
            (_ctx.IsSkillSpecializationExists)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'circle-exclamation'],
                    size: "sm",
                    class: "mr-1"
                  }),
                  _hoisted_27
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _withDirectives(_createElementVNode("select", {
              class: "neu-select",
              name: "statusFilter",
              id: "statusFilter",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedStatusFilter) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusFilter, (sts) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: sts.contractLaborShiftStatusId,
                  key: sts.contractLaborShiftStatusId
                }, _toDisplayString(sts.description), 9, _hoisted_30))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedStatusFilter]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _withDirectives(_createElementVNode("select", {
              class: "neu-select",
              name: "resultFilter",
              id: "resultFilter",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedResultFilter) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultFilter, (fac) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: fac.Value,
                  key: fac.Value
                }, _toDisplayString(fac.Text), 9, _hoisted_33))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedResultFilter]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createVNode(_component_neu_input, {
              name: "contractlaborid",
              modelValue: _ctx.contractlaborid,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.contractlaborid) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_neu_button, {
              type: "button",
              fill: "raised",
              id: "WFRequestStatusSearch",
              class: "float-end me-1",
              onClick: _ctx.searchClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" SEARCH ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        (_ctx.isShowWorkForceLoader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_font_awesome_icon, {
                  spin: true,
                  icon: ['fas', 'circle-notch'],
                  size: "lg"
                })
              ]),
              _hoisted_40
            ]))
          : _createCommentVNode("", true),
        (_ctx.isShowWorkForceGrid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createVNode(_component_neu_card, {
                color: "plain-0",
                class: "p-0 m-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_neu_table, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_neu_table_row, {
                        columns: _ctx.columnHeaders,
                        header: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                            return (_openBlock(), _createBlock(_component_neu_table_heading, {
                              key: column,
                              icon: _ctx.columnIcons[column],
                              slot: column,
                              style: {"padding-top":"25px !important"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(column), 1)
                              ]),
                              _: 2
                            }, 1032, ["icon", "slot"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["columns"]),
                      _createVNode(_component_neu_table_body, { align: "left" }, {
                        default: _withCtx(() => [
                          (_ctx.workforceRequestGridData != null && _ctx.workforceRequestGridData.length > 0)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.workforceRequestGridDataList, (wrkForce) => {
                                return (_openBlock(), _createBlock(_component_neu_table_row, {
                                  columns: _ctx.columnHeaders,
                                  key: wrkForce,
                                  slot: _ctx.column
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_neu_label, {
                                      slot: "Date",
                                      title: _ctx.buildDateTemplate(wrkForce.date)
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.buildDateTemplate(wrkForce.date)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["title"]),
                                    _createVNode(_component_neu_label, {
                                      slot: "Facilities",
                                      title: wrkForce.facility
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(wrkForce.facility), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["title"]),
                                    _createVNode(_component_neu_label, {
                                      slot: "Department",
                                      title: wrkForce.department
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(wrkForce.department), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["title"]),
                                    _createVNode(_component_neu_label, {
                                      slot: "Shift",
                                      title: wrkForce.shift
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(wrkForce.shift), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["title"]),
                                    _createVNode(_component_neu_label, {
                                      slot: "Skill",
                                      title: wrkForce.skill
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(wrkForce.skill), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["title"]),
                                    _createVNode(_component_neu_label, { slot: "Req Sent" }, {
                                      default: _withCtx(() => [
                                        (wrkForce.reqSent == null)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                                          : (wrkForce.reqSent)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                                _createVNode(_component_font_awesome_icon, {
                                                  icon: ['fas', 'check-circle'],
                                                  size: "lg",
                                                  class: "colorCheckCircle"
                                                })
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                _createVNode(_component_font_awesome_icon, {
                                                  icon: ['fas', 'times-circle'],
                                                  size: "lg",
                                                  class: "colorTimesCircle"
                                                })
                                              ]))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_neu_label, { slot: "Candidate Assigned" }, {
                                      default: _withCtx(() => [
                                        (wrkForce.candidateAssigned == null)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                                          : (wrkForce.candidateAssigned)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                _createVNode(_component_font_awesome_icon, {
                                                  icon: ['fas', 'check-circle'],
                                                  size: "lg",
                                                  class: "colorCheckCircle"
                                                })
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                _createVNode(_component_font_awesome_icon, {
                                                  icon: ['fas', 'times-circle'],
                                                  size: "lg",
                                                  class: "colorTimesCircle"
                                                })
                                              ]))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_neu_label, { slot: "Scheduled" }, {
                                      default: _withCtx(() => [
                                        (wrkForce.scheduled == null)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                                          : (wrkForce.scheduled)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                _createVNode(_component_font_awesome_icon, {
                                                  icon: ['fas', 'check-circle'],
                                                  size: "lg",
                                                  class: "colorCheckCircle"
                                                })
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                _createVNode(_component_font_awesome_icon, {
                                                  icon: ['fas', 'times-circle'],
                                                  size: "lg",
                                                  class: "colorTimesCircle"
                                                })
                                              ]))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_neu_label, { slot: "Cancelled" }, {
                                      default: _withCtx(() => [
                                        (wrkForce.cancelled == null)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                                          : (wrkForce.cancelled)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                _createVNode(_component_font_awesome_icon, {
                                                  icon: ['fas', 'check-circle'],
                                                  size: "lg",
                                                  class: "colorCheckCircle"
                                                })
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                _createVNode(_component_font_awesome_icon, {
                                                  icon: ['fas', 'times-circle'],
                                                  size: "lg",
                                                  class: "colorTimesCircle"
                                                })
                                              ]))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_neu_label, {
                                      slot: "Details",
                                      title: wrkForce.details
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(wrkForce.details), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["title"])
                                  ]),
                                  _: 2
                                }, 1032, ["columns", "slot"]))
                              }), 128))
                            : (_openBlock(), _createElementBlock("p", _hoisted_50, "No data available on current page."))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.workforceRequestGridData != null && _ctx.workforceRequestGridData.length > 0)
                ? (_openBlock(), _createBlock(_component_neu_container, {
                    key: 0,
                    fluid: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_neu_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_neu_col, {
                            md: "6",
                            cols: "12",
                            class: "neu-text-center neu-text-md-left"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_neu_paginator, {
                                class: "justify-content-start",
                                onVNeuChange: _cache[11] || (_cache[11] = (ev) => this.pageNum = ev.detail.pageNumber),
                                total: _ctx.workforceRequestGridData != null && _ctx.workforceRequestGridData.length,
                                rowsPerPage: _ctx.rowsPerPage
                              }, null, 8, ["total", "rowsPerPage"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_neu_col, {
                            md: "6",
                            cols: "12",
                            class: "neu-text-center neu-text-md-right"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_neu_table_row_count, {
                                class: "mt-3",
                                section: "number",
                                total: _ctx.workforceRequestGridData != null && _ctx.workforceRequestGridData.length,
                                "page-number": _ctx.pageNum,
                                onVNeuChange: _ctx.rowCountChange
                              }, null, 8, ["total", "page-number", "onVNeuChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}